import React from 'react';

export default function UpgradeModal({ onClose, reason, message }) {
  const plans = [
    { id: 'starter', name: 'Starter', price: '$19/mo', credits: '100', features: ['5 projects', 'Vercel deploy', 'Email support'] },
    { id: 'pro', name: 'Pro', price: '$49/mo', credits: '500', features: ['Unlimited projects', 'All deploys', 'Git integration', 'Priority queue'] },
    { id: 'team', name: 'Team', price: '$99/mo', credits: '2000', features: ['Everything in Pro', '5 team seats', 'Admin dashboard'] },
  ];

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={s.close}>✕</button>
        <div style={s.header}>
          <span style={{ fontSize: 36 }}>⚡</span>
          <h2 style={s.title}>Upgrade Your Plan</h2>
          <p style={s.subtitle}>{message || 'Get more credits and unlock premium features.'}</p>
        </div>

        <div style={s.plans}>
          {plans.map(p => (
            <div key={p.id} style={{ ...s.planCard, border: p.id === 'pro' ? '2px solid #6366f1' : '1px solid var(--border)' }}>
              {p.id === 'pro' && <span style={s.recommended}>RECOMMENDED</span>}
              <h3 style={s.planName}>{p.name}</h3>
              <div style={s.price}>{p.price}</div>
              <div style={s.credits}>{p.credits} credits/month</div>
              <ul style={s.features}>
                {p.features.map((f, i) => <li key={i} style={s.feature}>✓ {f}</li>)}
              </ul>
              <button style={{ ...s.btn, background: p.id === 'pro' ? '#6366f1' : 'var(--bg-input)' , color: p.id === 'pro' ? '#fff' : 'var(--text-primary)' }}>
                Choose {p.name}
              </button>
            </div>
          ))}
        </div>

        <p style={s.footer}>Cancel anytime. 7-day money-back guarantee.</p>
      </div>
    </div>
  );
}

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  modal: { background: 'var(--bg-card)', borderRadius: 16, padding: '32px', maxWidth: 720, width: '100%', position: 'relative', maxHeight: '90vh', overflow: 'auto' },
  close: { position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 18, cursor: 'pointer' },
  header: { textAlign: 'center', marginBottom: 24 },
  title: { fontSize: 22, fontWeight: 700, color: 'var(--text-primary)', margin: '8px 0 4px' },
  subtitle: { fontSize: 14, color: 'var(--text-secondary)' },
  plans: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 },
  planCard: { borderRadius: 12, padding: '20px 16px', textAlign: 'center', position: 'relative', background: 'var(--bg-secondary)' },
  recommended: { position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)', background: '#6366f1', color: '#fff', fontSize: 9, fontWeight: 700, padding: '2px 8px', borderRadius: 4 },
  planName: { fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 },
  price: { fontSize: 24, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 4 },
  credits: { fontSize: 12, color: '#6366f1', fontWeight: 600, marginBottom: 12 },
  features: { listStyle: 'none', padding: 0, margin: '0 0 16px', textAlign: 'left' },
  feature: { fontSize: 12, color: 'var(--text-secondary)', padding: '3px 0' },
  btn: { width: '100%', padding: '10px', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  footer: { textAlign: 'center', fontSize: 12, color: 'var(--text-muted)', marginTop: 20 },
};
